import React from 'react'
import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

export type IconPeopleProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
  ariaHidden?: boolean
}

export const IconPeople: React.FC<IconPeopleProps> = ({ ...props }) => {
  return (
    <MySvgIcon width="20px" viewBox="0 0 20 20" version="1.1" {...props}>
      <g fill="currentColor" fillRule="nonzero">
        <g transform="translate(0.000000, 3.055556)">
          <path d="M6,7 C7.934375,7 9.5,5.434375 9.5,3.5 C9.5,1.565625 7.934375,0 6,0 C4.065625,0 2.5,1.565625 2.5,3.5 C2.5,5.434375 4.065625,7 6,7 Z M8.4,8 L8.140625,8 C7.490625,8.3125 6.76875,8.5 6,8.5 C5.23125,8.5 4.5125,8.3125 3.859375,8 L3.6,8 C1.6125,8 0,9.6125 0,11.6 L0,12.5 C0,13.328125 0.671875,14 1.5,14 L10.5,14 C11.328125,14 12,13.328125 12,12.5 L12,11.6 C12,9.6125 10.3875,8 8.4,8 Z M15,7 C16.65625,7 18,5.65625 18,4 C18,2.34375 16.65625,1 15,1 C13.34375,1 12,2.34375 12,4 C12,5.65625 13.34375,7 15,7 Z M16.5,8 L16.38125,8 C15.946875,8.15 15.4875,8.25 15,8.25 C14.5125,8.25 14.053125,8.15 13.61875,8 L13.5,8 C12.8625,8 12.275,8.184375 11.759375,8.48125 C12.521875,9.303125 13,10.39375 13,11.6 L13,12.8 C13,12.86875 12.984375,12.934375 12.98125,13 L18.5,13 C19.328125,13 20,12.328125 20,11.5 C20,9.565625 18.434375,8 16.5,8 L16.5,8 Z"></path>
        </g>
      </g>
    </MySvgIcon>
  )
}
